import { FC } from "react";

import { VStack } from "@chakra-ui/react";
import { Form } from "formik";
import { useTranslation } from "next-i18next";

import { Button } from "@components/buttons";
import { Typography } from "@components/common";
import EmailInput from "@components/EmailInput";
import useFormErrors from "@hooks/useFormErrors";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { TForgotPasswordFormFieldsProps } from "../types";

const vStackSyle = {
  alignItems: "stretch",
  maxWidth: responsiveStyle({ mobile: "100%", desktop: "22.25rem" }),
  marginLeft: "auto",
  marginRight: "auto",
};
const centeredStyle = { alignSelf: "center" };

const ForgotPasswordFormFields: FC<TForgotPasswordFormFieldsProps> = ({ isLoading, errors }) => {
  const { t } = useTranslation();
  useFormErrors(errors);

  return (
    <Form noValidate>
      <VStack spacing={responsiveStyle({ mobile: "1.5rem", desktop: "3rem" })} mb="1.5rem">
        <Typography type="sectionHeading" sx={centeredStyle}>
          {t("password_recovery-form-forgot_password_title")}
        </Typography>

        <Typography type="body" sx={centeredStyle}>
          {t("password_recovery-form-forgot_password_description")}
        </Typography>
      </VStack>
      <VStack spacing={responsiveStyle({ mobile: "4rem", desktop: "2.5rem" })} sx={vStackSyle}>
        <EmailInput
          name="email"
          placeholder={t("password_recovery-field_names-email")}
          label={t("password_recovery-field_names-email")}
        />

        <Button
          label={t("password_recovery-button-send_the_link")}
          id="password_recovery-form-submit-button"
          type="submit"
          isLoading={isLoading}
          sx={{ alignSelf: responsiveStyle({ mobile: "stretch", desktop: "center" }) }}
        />
      </VStack>
    </Form>
  );
};
export default ForgotPasswordFormFields;
